import { oz } from '@weft/utils';
import { CreditPromotionModelInputSchema, FreeTrialPromotionModelInputSchema } from './promotion-model-input-schemas';
import { PercentagePromotionModelInputSchema } from './promotion-model-input-schemas';

export const PromotionModelInputSchema = oz.discriminatedUnion('promotionType', [
  CreditPromotionModelInputSchema,
  FreeTrialPromotionModelInputSchema,
  PercentagePromotionModelInputSchema,
]).openapi('PromotionModelInput');

export type PromotionModelInput = oz.infer<typeof PromotionModelInputSchema>;